import React from 'react';

import QuickLinks from './QuickLinks/QuickLinks';

import bulb from '../../assets/dashboard-icons/bulb.png';

import './css/AnchorDashboard.css';
import AnchorDashboardHeader from '../../components/AnchorDashboardHeader/AnchorDashboardHeader';


class AnchorDashboard extends React.Component {

  render() {
    const anchorFirstName = this.props.user.user.account.anchor.name.split(' ')[0];

    return (
      <div className="anchor-dashboard-min-height" id="dashboard">
        <AnchorDashboardHeader heading={`Hello ${anchorFirstName}`} />
        <div className="container anchor-dashboard">
          <div className="row">
            <div className="dashboard-snapshot col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <p className="dashboard-snapshot__title">Welcome to your Anchor Portal.</p>
            </div>
            <QuickLinks />
            <div className="dashboard-section-title col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h3>Did you know?</h3>
            </div>
            <div className="dashboard-did-you-know col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <img alt="Bulb" src={bulb} />
              <span>You can’t change to landscape mode once you start a live stream in portrait mode. This is because when switching cameras, the stream stops and starts again, which disconnects the overall stream.</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AnchorDashboard;
